const angular = require('angular')
const uniqBy = require('lodash/uniqBy')
const some = require('lodash/some')
const forEach = require('lodash/forEach')
const findIndex = require('lodash/findIndex')
const flatten = require('lodash/flatten')
const map = require('lodash/map')
const find = require('lodash/find')
const filter = require('lodash/filter')

module.exports = ['$scope', '$location', '$rootScope', '$stateParams', '$translate', '$timeout', '$cookies',
  '$ionicPopup', '$phoneModal', '$q', '$message', '$ionicActionSheet', '$utils', 'composeService', 'mailService',
  'netFolderService', 'User', '$state', '$ionicHistory', 'signatureService', 'LocalStorage', 'contactService',
  'Promise', '$window', '$sce', '$$html', '$$misc', '$loading', 'globalMailService',
  function ($scope, $location, $rootScope, $stateParams, $translate, $timeout, $cookies,
    $ionicPopup, $phoneModal, $q, $message, $ionicActionSheet, $utils, composeService, mailService,
    netFolderService, User, $state, $ionicHistory, signatureService, LocalStorage, contactService,
    Promise, $window, $sce, $$html, $$misc, $loading, globalMailService) {
    initCompose()
    let backFromCloudStorage = false // 判断是否从网盘返回
    const fromId = ($ionicHistory.backView() && $ionicHistory.backView().stateParams && $ionicHistory.backView().stateParams.fid) || 1
    $scope.cloudStorages = []
    const mboxa = $state.params.mboxa || ''
    // 初始化写信页
    function initCompose() {
      if ($rootScope.settings.wechatMiniProgram) {
        // 展示header
        $rootScope.settings.wechatMiniShowHeader = true
        console.log('$scope:' + $rootScope.settings.wechatMiniShowHeader)
      }

      // 开启定时自动保存草稿
      if ($rootScope.settings.enableAutoSaveDraft) {
        AutoSaveDraft()
      }
      // 每隔15s连服务器一次
      $scope.connectServerInterval = setInterval(function () {
        globalMailService.connectServer()
      }, 15000)
      // 标记操作的mid, 注意存草稿后，应重设当前的mid，使得在页面上总是操作此封草稿
      $scope.mid = $stateParams['mid']
      // 标记操作的类型，compose 新建写信 forward 转发 以及 reply 回复 restore 写草稿 sendAgain 再次发送 netFolder, sendAsAttachment附件转发,默认新建写信
      const action = $stateParams['action'] || 'compose'
      $scope.action = action
      $scope.composeId = action == 'compose' ? $scope.mid : ''
      $scope.lastComposeObj = {} // 记录初始化时保存的写信对象
      // 回复操作则光标直接到正文
      $scope.replyAutoFocus = (action === 'reply' || action === 'replyAll')
      // 联系人列表
      $scope.addressList = { to: [], cc: [], bcc: [] }
      // 附件列表
      $scope.attachments = []
      $scope.emailEditing = false

      // 标记是否以摘要形式显示抄送/暗送
      $scope.showSummary = true
      $scope.showSender = false
      initTo() // 初始化收件人
      initSender() // 初始化发件人，并设置当前登录账号为默认发信账号
      contactService.getPersonalGroups() // 提前获取个人通讯录分组列表，用于自动匹配的个人通讯录联系人部门信息展示
    }
    // 初始化收件人
    function initTo() {
      let mailTo = []
      if ($stateParams['email']) {
        mailTo.push($stateParams['email'])
      }
      if ($location.$$search.to) {
        let mails = $location.$$search.to || ''
        mails = mails.split(',').filter(item => {
          return $utils.$email.test(item)
        })
        mailTo = mailTo.concat(mails)
      }
      mailTo = composeService.constructRcpts(mailTo) || []
      if (!$scope.addressList) {
        $scope.addressList = {}
      }
      $scope.addressList.to = mailTo
    }
    // 初始化发件人
    function initSender() {
      // 准备数据，页面正在加载
      $scope.isLoading = true
      composeService.getAccounts().then(function (accounts) {
        // 发送人账号数组，可能出现多账号
        $scope.accounts = accounts.map(acc => {
          const matchList = acc.match(/^(\[\S*\])(\S*)/)
          return {
            label: acc,
            email: matchList ? matchList[2] : acc
          }
        })
        // 当前设定的发送人账号
        if (!$scope.isDraft) {
          $scope.sender = $scope.accounts[0].email
        }
        if ($rootScope.settings.wechatMiniProgram) {
          setTimeout(() => {
            $scope.showSender = true
          })
        } else {
          $scope.showSender = true
        }
        initComposeType($scope.action, $scope.composeId, $scope.mid)
      }, function (error) {
        initComposeError(error)
      })
    }
    // 初始化写信类型
    function initComposeType(action, composeId, mid) {
      switch (action) {
        case 'compose':
          if (composeId) {
            composeService.getComposeInfo(composeId).then(initScopeParam, function (error) {
              // composeService.composeMail0().then(initScopeParam);
              initComposeError(error)
            })
          } else {
            composeService.composeMail0().then(initScopeParam, function (error) {
              initComposeError(error)
            })
          }
          break
        case 'forward':
          composeService.forwardMail(mid, mboxa).then(initScopeParam, function (error) {
            initComposeError(error)
          })
          break
        case 'reply':
        case 'replyAll':
          composeService.replyMail(mid, action == 'replyAll', mboxa).then(initScopeParam, function (error) {
            initComposeError(error)
          })
          break
        case 'sendAgain':
          composeService.sendAgain(mid, mboxa).then(function (res) {
            initScopeParam(res, true)
          }, function (error) {
            initComposeError(error)
          })
          break
        case 'restore':
          const autoSaveDraftId = localStorage.getItem('autoSaveDraftId')
          composeService.restoreMail(autoSaveDraftId || mid, mboxa).then(function (res) {
            const result = res
            result.isDraft = true
            $scope.isDraft = true
            initScopeParam(result)
          }, function (error) {
            initComposeError(error)
          })
          break
        case 'composeWithNetfolderFile':
          composeWithNetfolderFile()
          break
        case 'composeWithTrsFile':
          composeWithTrsFile()
          break
        case 'composeWithInternalAttachment':
          composeWithInternalAttachment()
          break
        default:
          break
      }
    }
    // 写信页面初始化失败的处理
    function initComposeError(error) {
      console.log(error)
      $scope.isLoading = false
      if ($scope.composeDestory) {
        return
      }
      $ionicPopup.confirm({
        title: $translate.instant('TIPS.SYSTEM_MESSAGE'),
        template: $translate.instant('TIPS.LOADING_FAILED'),
        buttons: [
          {
            text: $translate.instant('OP.CANCEL'),
            type: 'button-positive',
            onTap: function () {
              exitCompose()
            }
          },
          {
            text: $translate.instant('OP.RELOAD'),
            type: 'button-default',
            onTap: function () {
              initSender()
            }
          }
        ]
      })
    }

    // 根据composeService各函数返回的邮件结构初始化scope中的变量
    function initScopeParam(mail, isSendAgain) {
      // 写信id
      $scope.id = mail.id
      $scope.composeId = mail.id
      // const sendAgain = isSendAgain || false
      // 草稿箱则使用传入的发件人账号
      if ($scope.isDraft && User.getSelectedAccountAccess() !== -1) {
        $scope.sender = mail.sender
      }
      // 收件人、抄送、密送
      $scope.addressList = {
        to: ($scope.addressList.to.concat(mail.to || [])).unique('email'),
        cc: $scope.addressList.cc.concat(mail.cc || []),
        bcc: $scope.addressList.bcc.concat(mail.bcc || [])
      }

      // 主题
      if (mail.subject) {
        $scope.subject = mail.subject
      }

      // 正文内容
      if (mail.content) {
        $scope.content = mail.content
      }

      // 引用内容，回复、转发
      $scope.quoteContent = ''
      if (!mail.content && mail.quoteContent) {
        $scope.quoteContent = '<div class="quoteHtml" style="margin-top:20px;">' + mail.quoteContent + '</div>'
      }

      // 获取签名档（不管成功还是失败都返回，防止读取邮件失败）
      const signaturesDefer = !mail.isDraft ? signatureService.getSignatures().then(function (data) {
        const index = findIndex(data.var || [], item => item.isDefault)
        if (index === -1) return $q.reject('signature default is null')

        const content = !data.var[index].isHtml
          ? data.var[index].content.replace(/\n/g, '<br />')
          : $sce.trustAsHtml($utils.$html.filterXSS(data.var[index].content))
        return `<div class="signatureContainer">${content}</div>`
      }).catch(err => {
        console.log(err)
        return ''
      }) : $q.resolve('')

      // 编辑区
      $scope.composeEditContainer = ''
      if (~['reply', 'replyAll'].indexOf($scope.action)) { // ['reply', 'replyAll', 'sendAgain' , 'forward']
        const quickReply = LocalStorage.getItem('quickReply')
        if (quickReply.mid === $stateParams['mid']) {
          $scope.composeEditContainer = `<div>${quickReply.content}<br><br></div>`
          LocalStorage.removeItem('quickReply')
        }
      }
      $q.all([signaturesDefer, $q.resolve($scope.quoteContent)]).then(res => {
        $scope.defaultSignatureContent = res[0]
        if ((res[0] || res[1]) && !$scope.composeEditContainer && !['sendAgain', 'restore'].includes($scope.action)) {
          $scope.composeEditContainer = '<div><br><br><br></div>'
        }
        const userConfig = User.getConfig()
        // 签名档添加的位置
        // signature_position: 0 (default) - absolute 整个文档底部
        //                     1           - related  正文之后, 引用文本之前
        const signaturePosition = parseInt(userConfig.signature_position || 0)
        if (!~[0, 1].indexOf(signaturePosition)) return

        let orderArr = [$scope.composeEditContainer]
        if (signaturePosition === 0) {
          orderArr = orderArr.concat([$scope.quoteContent, $scope.defaultSignatureContent])
        } else if (signaturePosition === 1) {
          orderArr = orderArr.concat([$scope.defaultSignatureContent, $scope.quoteContent])
        }
        $scope.defaultContent = $utils.$html.filterMailContent(orderArr.join(''), $rootScope.settings.mailContentMaxLimit)
        setTimeout(_ => ($scope.lastComposeObj = angular.copy(getComposeObject(), {})))
      })

      $scope.doSending = false
      $scope.isLoading = false

      // 附件内容（转发或带附件回复时有用）
      if ($scope.action != 'netFolder' && mail.attachments.length > 0) {
        if ($scope.action == 'forward' || $scope.action == 'restore' || $scope.action == 'compose') {
          for (let i = 0; i < mail.attachments.length; i++) {
            mail.attachments[i].bytesLoaded = 100
            mail.attachments[i].deleted = false
            mail.attachments[i].status = 'ok'
            mail.attachments[i].statusTip = $translate.instant('ATTACH.UPLOAD_SUCCESS')
            mail.attachments[i].formattype = $utils.$attachment.getIconClass(mail.attachments[i].name, mail.attachments[i].contentType)
          }
        }
        $scope.attachments = mail.attachments
      }

      $scope.checkAllRcpts()
      $scope.changeTitle($scope.subject)
    }
    // netfolder类型文件作为附件写信（对应场景：从文件中心企业网盘，个人网盘进入写信）
    function composeWithNetfolderFile() {
      const netFoldFile = netFolderService.getComposeFile()
      if (netFoldFile) {
        const attachment = {
          type: 'netfolder',
          _mid: netFoldFile.id,
          displayName: netFoldFile.name,
          name: netFoldFile.name,
          contentType: netFoldFile.contentType,
          size: netFoldFile.size,
          securityLevel: null,
          deleted: false
        }
        if (netFoldFile.folderType === 'ent') {
          attachment._enfUid = netFolderService.getUid()
        }
        const data = {
          returnInfo: true,
          attrs: {
            attachments: [attachment]
          }
        }
        mailService.compose($scope.composeId, data, 'continue').then(function (data) {
          if (data && data.code === 'S_OK') {
            updateComposeAttachmentList(data.var.attachments)
            initScopeParam(data.var)
          }
        }, function (error) {
          initComposeError(error)
        })
      }
    }
    // netfolder类型文件作为附件写信（对应场景：从文件中心文件中转站进入写信）
    function composeWithTrsFile() {
      const netFoldFile = netFolderService.getComposeFile()
      if (netFoldFile) {
        const attachment = {
          type: 'trs',
          _mid: netFoldFile.id,
          displayName: netFoldFile.name,
          name: netFoldFile.name,
          contentType: netFoldFile.contentType,
          size: netFoldFile.size,
          securityLevel: null,
          deleted: false
        }
        const data = {
          returnInfo: true,
          attrs: {
            attachments: [attachment]
          }
        }
        mailService.compose($scope.composeId, data, 'continue').then(function (data) {
          if (data && data.code === 'S_OK') {
            updateComposeAttachmentList(data.var.attachments)
            initScopeParam(data.var)
          }
        }, function (error) {
          initComposeError(error)
        })
      }
    }
    // internal类型文件作为附件写信（对应场景： 从文件中心来往附件或者读信界面选择附件进入写信）
    function composeWithInternalAttachment() {
      const internalFile = netFolderService.getComposeFile()
      if (internalFile) {
        const attachment = {}
        attachment._mid = internalFile.path
        if (internalFile.partId) {
          attachment._part = internalFile.partId
        } else {
          attachment._part = '_' + internalFile.contentOffset
        }
        attachment.type = 'internal'
        const data = {
          returnInfo: true,
          attrs: {
            attachments: [attachment]
          }
        }
        mailService.compose($scope.composeId, data, 'continue').then(function (data) {
          if (data && data.code === 'S_OK') {
            updateComposeAttachmentList(data.var.attachments)
            initScopeParam(data.var)
          }
        }, function (error) {
          initComposeError(error)
        })
      }
    }

    // 获取附件列表的第一个附件的名称
    $scope.attachmentsfirstname = function () {
      if ($scope.attachments.length) {
        return $scope.attachments[0].name
      } else if ($scope.cloudStorages.length) {
        return $scope.cloudStorages[0].name
      } else return ''
    }

    $scope.attachmentStatus = function () {
      const iconClass = {
        'failed': 'icon-upload_failed',
        'uploading': 'icon-uploading'
      }
      for (let i = 0; i < $scope.attachments.length; i++) {
        const curAttachment = $scope.attachments[i]
        if (['failed', 'uploading'].includes(curAttachment.status) && curAttachment.deleted == false) {
          $scope.isUploadSuccess = false
          return iconClass[curAttachment.status]
        }
      }
      $scope.isUploadSuccess = true
      return 'icon-upload_success'
    }
    // 附件数量
    $scope.attachmentNo = function () {
      return $scope.attachments.length + $scope.cloudStorages.length
    }
    $scope.showAttachmentInfo = function () {
      return $scope.attachments.length || $scope.cloudStorages.length
    }

    // 本地附件上传具体过程(isUpdate是否上传后更新附件列表)
    function getUploadHandler(uploadFile, isUpdate = true) {
      return composeService.prepareUpload(uploadFile, $scope.composeId).then(res => {
        const resVar = res.var || {}
        /*
        * TODO: 这里似乎没有用处，倒是修改后可能id冲突，故调整
        * http://git.mailtech.cn/lunkr/hxphone-main/-/commit/793ce1c8897fb7bddd3038026bee0aa31ca1d505
        * uploadFile.id = file.status == 'failed' ? resVar.attachmentId - 1 : resVar.attachmentId
        */
        uploadFile.id = resVar.attachmentId
        uploadFile.status = 'uploading'

        return composeService.directorUpload($scope.composeId, resVar.attachmentId, uploadFile).then(res => {
          if (res.var.actualSize === 0) return $q.reject({code: 'FA_UPLOAD_ACTUALSIZE_0', var: res.var})

          uploadFile.bytesLoaded = 100
          uploadFile.status = 'ok'
          uploadFile.statusTip = $translate.instant('ATTACH.UPLOAD_SUCCESS')

          // 更新文件列表
          isUpdate && mailService.getComposeInfo({ id: $scope.composeId }).then(res => {
            updateComposeAttachmentList(res.attachments)
          }, err => {
            console.log('getUploadHandler refresh failed:' + JSON.stringify(err))
          })
        }, null, progress => {
          uploadFile.bytesLoaded = progress
        })
      }).catch(err => {
        err = err || {}
        uploadFile.bytesLoaded = 0
        uploadFile.status = 'failed'
        uploadFile.statusTip = $translate.instant('ATTACH.UPLOAD_FAILED')
        let tip = ''
        if (err.code === 'FA_UPLOAD_SIZE_EXCEEDED' || err.code === 'FA_OVERFLOW') {
          tip = getOverflowReason(err.overflowReason)
        } else if (err.code == 'FA_UPLOAD_ACTUALSIZE_0') {
          tip = $translate.instant('CODE.COMPOSE.FA_UPLOAD_ACTUALSIZE_0')
        } else {
          tip = $translate.instant(err.code)
        }
        showTip(tip)
        console.log('getUploadHandler uplodad failed:' + JSON.stringify(err))
      })
    }
    // 根据Scope中双向绑定的数据，构建提交表单时需要使用的composeObject，
    // 通过深度对比本函数前后两次返回的对象，可用于（定时）保存草稿等功能
    function getComposeObject() {
      const composeEditZone = document.getElementById('compose-edit-zone')
      const composeContent = composeEditZone.innerHTML || ''
      function _buildRcptsArr(arr) {
        const rcptsArr = []
        for (let i = 0; i < arr.length; i++) {
          rcptsArr.push(arr[i].address)
        }
        return rcptsArr
      }
      if ($scope.seniorOption && $scope.seniorOption[1].value) {
        $scope.addressList.cc = []
        $scope.addressList.bcc = []
      }
      const composeObject = {
        id: $scope.id,
        account: $scope.sender,
        to: _buildRcptsArr($scope.addressList.to),
        cc: _buildRcptsArr($scope.addressList.cc),
        bcc: _buildRcptsArr($scope.addressList.bcc),
        subject: $scope.subject,
        content: composeContent.replace(/contenteditable="true"/g, ''),
        attachments: $scope.attachments,
        isHtml: true,
        saveSentCopy: true,
        charset: 'gbk'
      }
      if ($scope.cloudStorages.length) {
        const newComposeEditZone = composeEditZone.cloneNode(true)
        const files = []
        const cloudStorage = $scope.cloudStorages
        cloudStorage.forEach(function (item) {
          files.push('<div class="gxItem" style="margin-bottom:12px;"><p class="name" title="' + item.name + '" style="margin: 0 0 6px;">' + item.name + '<span style="color:#aaa;padding-left:6px;">(' + item.size + ')</span></p><a href="' + item.path + '" class="link" style="color: #1486CA;cursor:pointer;" target="_blank">查看下载信息</a></div>')
        })
        const cloudStorageStringStyle = '</br><div id="thirdNetFolder" style="margin:6px 0;"><div class="title" style="border:1px solid #d8d8d8;background-color:#F2F4F5;color:#000;padding:4px 0;font-size:16px;vertical-align:middle;"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAADhUlEQVRYR+2WTWgcZRjH///Z3bSRQkxnbP0AEa0fIKg1u7OYQKFSaEn9iEXQ4kHBgyc9VLTdGW2iZiaWikr1Ij2ol1qEQEoxVD2YUlqY2VjaSj3YGlqkkZaZ/UBjEzMzj2zqlnS728xuDr1kjjP/53l+7/993ucd4iY/vMn1sQSw5MDCDnwxntL8qFvAHkrUFqdpBZwJBUdLwdQxDKwPbhSzIIBmO/sAbo1TuFYjIvt8M/tSywAdH4zfl1Si3wDs8jWlH6+lZ2OBDJxuU1NTAwC2B5HyQPnd9O+N4m7ogGo5r5Pcg0TyLm/745Oxiv8v0nYdvxNhcEFE3vDN7GetAnxNYpNnZFfXJlAHnedA9JGcCcGRopEZrdVotnNRBId8M/tyqwC/Ajzrm/oz8xOolvsKiS8hckaIFMF7oojPF97JDM/XabZ7UCD3+kb24eYBPj7Wrk0n/4mA/oKhv19NoA65GUYYA3DYM/XeynvVcg4BeCJAYn3ZTB+varWhfL9EstNvD1ZgW/flehANe+DWQXddUsHhENx81d49Z5apfxUugZwMyM3lXGaikrTSrKlENCqA6v87dXv16Gm28xTAgyFkXdHIHmkKQLPcN0F8NJ1atvrvtx69NLfSyuoFbijcWjQz+6/ZlsH8s1RkJBCsLZn6icq3FbtPrlo+O3MxEtlWMLOfNAvwjQA9vqnfXQ3sGDrVmZTL5wH8QeEwIFH1mxCbIOgKlPZV5dwjxatbZrsXIDLWaB403ALNcs8KcMo39S3zyTvtfI8i0acgu4grt6kAQpFfRFH2+rnM59c4Y7sHCDzkGfqDsR3o/HC8IxFFJQFN38jYzZz/Wu1K292pAO95y4Nb6jViXQfUofwGivwYUdlYyKV/WAxAp53vTUC+gyhPemb6p9pc9QEsN0fCvnLOuaZqdbMgIohImQC4BsK3PTOzOx6A7Q4T2ALIKIQ/z2+25iCogNIFsBeCbz1TfyEWgGY5EyBnGzVOHAjVdvpCtp0o7XjsvGq7p0mkPCN7fywA1XY9iBzwzeyrcYrV06iWcw7ggG/qX2mWuxdAn2fqt8UDsJwRkhtCcGPRyBxtFaISt3LQ7VYo34Mc8wz96VgAmjV+BxidBHAdcSswAkyGTPWUcmvPxQKYm+9zU2/6RYpcdxU3BUHlz1Dh/uKOdDn2IGqqwCLFC/4TLjL/guFLAEsO/AeJyGQwGDhrfAAAAABJRU5ErkJggg==" style="color: #1486CA; font-size: 30px;margin-right: 6px; margin-left: 8px; vertical-align: middle;"></img><span style="display: inline-block; vertical-align: middle;">' + $translate.instant('ATTACH.SELECT_FROM_CLOUD_STORAGE', { name: $rootScope.nf_name }) + '</span></div><div class="detail" style="border:1px solid #d8d8d8;border-top:none;padding:12px 12px 0;background-color:#fff;font-size:13px;line-height:1.5;">' + files.join('') + '</div></div>'
        const cloudStorageHTMLStyle = document.createElement('div')
        cloudStorageHTMLStyle.innerHTML = cloudStorageStringStyle
        const quoteHtml = newComposeEditZone.querySelector('#compose-edit-zone .quoteHtml') // 内容存在引用
        const signatureContainer = newComposeEditZone.querySelector('#compose-edit-zone .signatureContainer') // 内容存在签名档
        const gxItem = newComposeEditZone.querySelector('#compose-edit-zone .gxItem') // 内容存在cloudStorage样式信息
        if ($scope.isDraft) { // 草稿
          const content = $scope.content || $scope.quoteContent
          if (~content.indexOf('<div class="gxItem"')) {
            // 存在第三方附件
            const csIndex = content.indexOf('<div class="gxItem"')
            const quoteIndex = content.indexOf('<div class="quoteHtml"')
            // 附件在引用前， 附件在引用后
            if (csIndex > quoteIndex) {
              newComposeEditZone.innerHTML = content.replace(/<div class="gxItem"/, files.join('') + '<div class="gxItem"')
            } else newComposeEditZone.insertBefore(cloudStorageHTMLStyle, gxItem)
          } else {
            // 是否存在引用
            if (quoteHtml) newComposeEditZone.insertBefore(cloudStorageHTMLStyle, quoteHtml)
            else { // 不存在引用，但判断签名档存在
              if (signatureContainer) newComposeEditZone.insertBefore(cloudStorageHTMLStyle, signatureContainer)
              else newComposeEditZone.appendChild(cloudStorageHTMLStyle)
            }
          }
        } else { // 非草稿
          // 存在引用
          if (quoteHtml) newComposeEditZone.insertBefore(cloudStorageHTMLStyle, quoteHtml)
          else { // 不存在引用，判断签名档是否存在
            if (signatureContainer) newComposeEditZone.insertBefore(cloudStorageHTMLStyle, signatureContainer)
            else newComposeEditZone.appendChild(cloudStorageHTMLStyle)
          }
        }
        composeObject.content = newComposeEditZone.innerHTML
      }
      // 添加高级选项
      if ($scope.seniorOption && angular.isArray($scope.seniorOption) && $scope.seniorOption.length !== 0) {
        formatSeniorOption($scope.seniorOption)
        $scope.seniorOption.forEach(function (option) {
          if (option.confirmUse) {
            composeObject[option.prop] = option.value
          }
        })
      }
      return composeObject
    }

    // 存草稿、发信失败时的处理
    function composeFailHandler(failResult) {
      $scope.doSending = false
      $scope.isLoading = false
      const sCode = failResult ? failResult.code : ''
      let msg = ''
      switch (sCode) {
        case 'FA_NEED_VERIFY_CODE':
          $scope.verifyCodeImgSrc = User.getCurrentUser().getVerifyCodeImgSrc()
          $scope.verifyCode = null
          $scope.verifyCodeModal = $phoneModal.fromTemplate(require('views/compose/verifyWindow.html'), {
            scope: $scope,
            animation: 'slide-in-up'
          })
          $scope.verifyCodeModal.el.style.zIndex = 11
          $scope.verifyCodeModal.show()
          break
        case 'FA_ATTACH_NOT_COMPLETED':
          msg = $translate.instant('CODE.COMPOSE.FA_ATTACH_NOT_COMPLETED')
          break
        case 'FA_FORBIDDEN':
          msg = $translate.instant('CODE.COMPOSE.FA_FORBIDDEN')
          break
        case 'FA_OVERFLOW':
          if (failResult['overflowReason']) {
            msg = getOverflowReason(failResult['overflowReason'])
          } else {
            msg = $translate.instant('CODE.COMPOSE.FA_OVERFLOW.OVERFLOW_OTHER_REASONS_MSG')
          }
          break
        case 'FA_NO_RECEIPT':
          msg = $translate.instant('CODE.COMPOSE.FA_NO_RECEIPT')
          break
        case 'FA_WRONG_RECEIPT':
          msg = $translate.instant('CODE.COMPOSE.FA_WRONG_RECEIPT')
          break
        case 'FA_INVALID_ACCOUNT':
          msg = $translate.instant('CODE.COMPOSE.FA_INVALID_ACCOUNT')
          break
        case 'FA_INVALID_DATE':
          msg = $translate.instant('CODE.COMPOSE.FA_INVALID_DATE')
          break
        case 'FR_INVALID_REQUEST':
          msg = $translate.instant('CODE.COMPOSE.FR_INVALID_REQUEST')
          break
        case 'FA_MTA_USER_BLACK_LIST':
          msg = $translate.instant('CODE.COMPOSE.FA_MTA_USER_BLACK_LIST')
          break
        case 'FA_MTA_TOO_MANY_RCPTS':
          msg = $translate.instant('CODE.COMPOSE.FA_MTA_TOO_MANY_RCPTS')
          break
        case 'FA_MTA_RCPT_ERROR':
          const contacts = flatten(map(['to', 'cc', 'bcc'], key =>
            map($scope.addressList[key] || [], 'address')
          ))
          const errorRcpts = map((failResult['errorRcpts'] || {}), (mtaCode, address) => {
            mtaCode = ~['MTA5104', 'MTA5107'].indexOf(mtaCode) ? mtaCode : 'ERROR_ACCOUNT_IS_BANNED'
            return {
              desc: $translate.instant(`CODE.COMPOSE.FA_MTA_RCPT_ERROR.${mtaCode}`),
              email: find(contacts, email => $utils.$email.parse(email).addr === address) || address
            }
          })
          // 方案 http://jira.mailtech.cn/browse/REQ-5630?focusedCommentId=1350974&page=com.atlassian.jira.plugin.system.issuetabpanels%3Acomment-tabpanel#comment-1350974
          // 需要具体失败原因需要打印，但是考虑到hxphone无法显示太多信息，这里不做打印
          const confirmPopup = $ionicPopup.confirm({
            template: $translate.instant('CODE.COMPOSE.FA_MTA_RCPT_ERROR.TIPS_EMAILS_ADDRS_BELOW_CANNOT_RECEIVE_MSG'),
            cancelText: $translate.instant('OP.NO'),
            cancelType: 'button-positive',
            okText: $translate.instant('OP.YES_SINGLE'),
            okType: 'button-default'
          })
          // 去除非法地址后发送
          const handleResend = function (invalidEmails) {
            angular.forEach(['to', 'cc', 'bcc'], key => {
              const addressList = $scope.addressList[key]
              if (!addressList || !addressList.length) return

              $scope.addressList[key] = filter(addressList, item => (!~invalidEmails.indexOf(item.address)))
            })
            setTimeout(composing())
          }
          // 标红非法地址
          const handleFlagInvalidEmail = function (invalidEmails) {
            let activeEditKeys = []
            angular.forEach(['to', 'cc', 'bcc'], key => {
              const addressList = $scope.addressList[key]
              if (!addressList || !addressList.length) return

              $scope.addressList[key] = map(addressList, item => {
                if (~invalidEmails.indexOf(item.address)) {
                  item.valid = false
                  activeEditKeys.push(key)
                }
                return item
              })
            })
            activeEditKeys = uniqBy(activeEditKeys)
            $scope.$broadcast('COMPOSE_ACTIVE_EMAIL_EDIT', activeEditKeys)
          }
          confirmPopup.then(function (res) {
            if (res) return handleResend(map(errorRcpts, 'email'))

            handleFlagInvalidEmail(map(errorRcpts, 'email'))
          })
          break
        case 'FA_MTA_REJECTED':
          msg = getMtaRejectedReason(failResult['mtaCode'])
          break
        default:
          if (sCode) {
            msg += $translate.instant('CODE.GLOBAL.' + sCode)
          }
          break
      }

      if (msg) {
        showTip(msg)
      }
    }

    // 发信被拒绝可能的原因
    function getMtaRejectedReason(mtaCode) {
      let message = ''
      const rejectedInfo = {
        4512: 'CODE.COMPOSE.FA_MTA_REJECTED.MTA5910',
        5510: 'CODE.COMPOSE.FA_MTA_REJECTED.MTA5510',
        5511: 'CODE.COMPOSE.FA_MTA_REJECTED.MTA5511',
        5520: 'CODE.COMPOSE.FA_MTA_REJECTED.MTA5520',
        5521: 'CODE.COMPOSE.FA_MTA_REJECTED.MTA5521',
        5522: 'CODE.COMPOSE.FA_MTA_REJECTED.MTA5522',
        5530: 'CODE.COMPOSE.FA_MTA_REJECTED.MTA5530',
        5531: 'CODE.COMPOSE.FA_MTA_REJECTED.MTA5531',
        5532: 'CODE.COMPOSE.FA_MTA_REJECTED.MTA5532',
        5540: 'CODE.COMPOSE.FA_MTA_REJECTED.MTA5910',
        5910: 'CODE.COMPOSE.FA_MTA_REJECTED.MTA5910',
        5911: 'CODE.COMPOSE.FA_MTA_REJECTED.MTA5911'
      }
      if (rejectedInfo[mtaCode]) {
        message = $translate.instant(rejectedInfo[mtaCode])
      } else {
        message = $translate.instant('CODE.COMPOSE.FA_MTA_REJECTED.REJECT_UNKNOWN_REASONS_MSG')
        if (mtaCode) {
          message += $translate.instant('CODE.GLOBAL' + mtaCode)
        }
      }
      return message
    }

    // 信件超出大小可能的原因
    function getOverflowReason(overflowReason) {
      const overFlowInfo = {
        'pref_quota': 'CODE.COMPOSE.FA_OVERFLOW.PREF_QUOTA',
        'pref_flow_limit': 'CODE.COMPOSE.FA_OVERFLOW.PREF_FLOW_LIMIT',
        'pref_smtp_max_num_rcpts': 'CODE.COMPOSE.FA_OVERFLOW.PREF_SMTP_MAX_NUM_RCPTS',
        'pref_smtp_max_mail_count': 'CODE.COMPOSE.FA_OVERFLOW.PREF_SMTP_MAX_MAIL_COUNT',
        'pref_smtp_max_send_mail_size': 'CODE.COMPOSE.FA_OVERFLOW.PREF_SMTP_MAX_SEND_MAIL_SIZE'
      }
      if (overFlowInfo[overflowReason]) {
        return $translate.instant(overFlowInfo[overflowReason])
      } else {
        return ''
      }
    }

    // 只有 主题、内容不为空，且至少存在一个收件人/抄送/密送时才能发送邮件
    $scope.enableSendButton = function () {
      const enable = ($scope.addressList.to.length > 0 || $scope.addressList.cc.length > 0 || $scope.addressList.bcc.length > 0) &&
        ($scope.subject || ($scope.content))
      return enable
    }

    // 删除上传失败附件
    $scope.deleteUploadFailAttachment = function () {
      const notFinishAttachments = filter($scope.attachments, item => (~['failed', 'uploading'].indexOf(item.status)))

      return notFinishAttachments.length
        ? composeService.deleteTasks($scope.composeId, map(notFinishAttachments, 'name'))
        : $q.resolve()
    }

    // 物理返回键
    $scope.$on('COMPOSE_CANCEL', function () {
      $scope.cancel()
    })
    // 发信中
    function composing() {
      if (isAttachmentSizeBeyondLimit()) {
        showTip($translate.instant('CODE.COMPOSE.FA_OVERFLOW.PREF_SMTP_MAX_SEND_MAIL_SIZE'))
        return
      }
      $scope.$broadcast('BLUR_EMAIL_ITEM_EDIT_INPUT')
      $scope.doSending = true
      $scope.isLoading = true
      composeService.composeMail1($scope.id, getComposeObject(), 'deliver', $scope.verifyCode).then(
        function () {
          $scope.doSending = false
          showTip($translate.instant('MAIL_OP_TIPS.SUCCESS_SEND_MAIL'))
          exitCompose()
        }, function (failResult) {
          composeFailHandler(failResult)
        }
      ).finally(function () {
        $scope.isLoading = false
      })
    }

    // 打开高级选项模态框
    $scope.openSeniorOptionModal = function () {
      $scope.authForbidForward = false
      if (User.getConfig().$ajc) {
        $scope.authForbidForward = User.getConfig().$ajc.user.enableSendWebReadOnlyMail
      }
      if (!$scope.seniorOption) {
        $scope.seniorOption = [
          {
            optionId: 0, // 选项Id
            optionName: $translate.instant('COMPOSE.FORBIDREPLY&FORWARD&DOWNLOAD'), // 禁止转发回复下载
            prop: 'forbidDownload', // 字段名
            value: false, // 未点击确认按钮时的高级选项的值
            tempValue: false, // 点击确定按钮后该值才会被赋值到value
            confirmUse: false, // 是否确认信件带上该字段
            isAuth: $scope.authForbidForward || false // 表示是否拥有该高级选项功能的权限
          }, {
            optionId: 1,
            optionName: $translate.instant('COMPOSE.SHOWONERCPT'), // 群发单显
            prop: 'showOneRcpt',
            value: false,
            tempValue: false,
            confirmUse: false,
            isAuth: true
          }, {
            optionId: 2,
            optionName: $translate.instant('COMPOSE.SETEMERGENCY'), // 设为紧急
            prop: 'priority',
            value: false,
            tempValue: false,
            confirmUse: false,
            isAuth: true
          }
        ]
      }
      $scope.seniorOptionModal = $phoneModal.fromTemplate(require('views/compose/seniorOptionModal.html'), {
        scope: $scope,
        cache: false,
        animation: 'fade-in-up'
      })
      $scope.seniorOptionModal.el.style.zIndex = 11
      $utils.$modalFunc.prepareModalBack($scope.seniorOptionModal)
      $scope.seniorOptionModal.show()
    }
    // 关闭高级选项模态框
    $scope.closeSeniorOptionModal = function () {
      $scope.seniorOption.forEach(function (option) {
        option.tempValue = option.value
      })
      $scope.showSeniorOptionList = showSeniorOptionList()
      $scope.seniorOptionModal.remove()
      $utils.$modalFunc.endModalBack()
    }
    // 处理高级选项点击操作
    $scope.handleSeniorOptionClick = function (option) {
      // 群发单显是否显示功能提示弹窗逻辑
      if (option.optionId === 1) {
        const hideBulkSingleTip = LocalStorage.getItem('hideBulkSingleTip')
        const hideBulkSingleTipInCurrentSession = LocalStorage.getItem('hideBulkSingleTipInCurrentSession')
        if (JSON.stringify(hideBulkSingleTip) === '{}' && JSON.stringify(hideBulkSingleTipInCurrentSession) === '{}') {
          const confirmPopup = $ionicPopup.confirm({
            template: $translate.instant('COMPOSE.SHOWONERCPT_TIP'),
            cancelText: $translate.instant('OP.NO_MORE_TIP'),
            cancelType: 'button-positive',
            okText: $translate.instant('OP.CONFIRM'),
            okType: 'button-default'
          })
          confirmPopup.then(function (res) {
            if (!res) {
              LocalStorage.setItem('hideBulkSingleTip', 'hide')
            }
          }).finally(function () {
            LocalStorage.setItem('hideBulkSingleTipInCurrentSession', 'hide')
          })
        }
      }
      option.tempValue = !option.tempValue
    }
    // 确定高级选项选择结果
    $scope.handleSeniorOptionConfirm = function () {
      $scope.seniorOption.forEach(function (option) {
        option.value = option.tempValue
        option.value ? option.confirmUse = true : option.confirmUse = false
      })
      extraOperationForSeniorOption()
      $scope.showSeniorOptionList = showSeniorOptionList()
      $scope.seniorOptionModal.remove()
      $utils.$modalFunc.endModalBack()
    }
    // 处理高级选项复选框点击操作
    $scope.handleSeniorOptionCheckbox = function (option) {
      option.value = false
      option.tempValue = false
      option.confirmUse = false
      if (option.optionId === 1) {
        removeBccCcAddress()
      }
      $scope.showSeniorOptionList = showSeniorOptionList()
    }
    // 判断是否在主题下方显示高级选项列表
    function showSeniorOptionList() {
      if ($scope.seniorOption) {
        let show = false
        $scope.seniorOption.forEach(function (option) {
          if (option.confirmUse) {
            show = true
          }
        })
        return show
      }
    }
    // 格式化高级选项
    function formatSeniorOption(options) {
      options.forEach(function (option) {
        // 设为紧急传递priority:1
        if (option.optionId === 3 && option.value) {
          option.value = 1
        }
      })
    }
    // 确定使用高级选项后的附加处理
    function extraOperationForSeniorOption() {
      // 若开启群发单送，则隐藏抄送密送并将地址合并到收件人
      if ($scope.seniorOption[1].confirmUse) {
        $scope.addressList.to = [...$scope.addressList.to, ...$scope.addressList.cc, ...$scope.addressList.bcc].unique('address')
      }
    }
    // 取消群发单显后移除收件人中的抄送密送的地址
    function removeBccCcAddress() {
      const tempTo = []
      const tempCcBcc = [...$scope.addressList.cc, ...$scope.addressList.bcc].unique('address')
      $scope.addressList.to.unique('address')
      $scope.addressList.to.forEach(function (address) {
        let isExist = false
        tempCcBcc.forEach(function (item) {
          if (address.address === item.address) {
            isExist = true
          }
        })
        !isExist && tempTo.push(address)
      })
      $scope.addressList.to = tempTo.unique('address')
    }
    // 点击发送
    $scope.send = function () {
      LA.track('A1D2B2')
      // 校验联系人地址是否正确（存在错误地址展开显示）
      let errorEmail = null

      find(['to', 'cc', 'bcc'], key => {
        errorEmail = find($scope.addressList[key] || [], item => !item.valid)
        errorEmail && (errorEmail.type = key)
        return errorEmail
      })
      if (errorEmail) {
        showTip($translate.instant('COMPOSE.EMAIL_NOT_EXIST').replace('{0}', errorEmail.address))
        $scope.$broadcast('COMPOSE_ACTIVE_EMAIL_EDIT', errorEmail.type)
        return
      }

      // 校验主题和内容是否为空
      let msgTemplate = ''
      $scope.content = document.getElementById('compose-edit-zone').innerHTML || ''
      if (!$scope.subject) {
        msgTemplate = $translate.instant('CODE.COMPOSE.NO_SUBJECT_TIP')
      } else if (!$scope.content.match(/[^(<br>)]/ig)) {
        msgTemplate = $translate.instant('CODE.COMPOSE.NO_CONTENT_TIP')
      }
      if (msgTemplate) {
        const confirmPopup = $ionicPopup.confirm({
          title: $translate.instant('TIPS.SYSTEM_MESSAGE'),
          template: msgTemplate,
          okText: $translate.instant('OP.CONFIRM'),
          cancelText: $translate.instant('OP.CANCEL')
        })
        confirmPopup.then(function (res) {
          _stopPropagation(event || window.event)
          res && validateAttachmentStatus() // 不带主题或内容发信
        })
      } else {
        validateAttachmentStatus() // 带主题或内容发信
      }
    }
    // 校验附件上传状态
    function validateAttachmentStatus() {
      if (!$scope.attachmentStatus()) { // 检测是否有附件上传失败
        $ionicPopup.confirm({
          title: $translate.instant('TIPS.SYSTEM_MESSAGE'),
          template: $translate.instant('CODE.COMPOSE.FILE_UPLOAD_FAILED_WHETHER_CONTINUE'),
          okText: $translate.instant('OP.CONTINUE_SEND'),
          cancelText: $translate.instant('OP.VIEW_ATTACHMENTS')
        }).then(function (res) {
          if (res) {
            $scope.deleteUploadFailAttachment().then(composing)
          } else {
            $scope.goFileCenter()
          }
        })
      } else {
        composing()
      }
    }
    // 取消写信
    $scope.cancel = function () {
      $scope.$broadcast('BLUR_EMAIL_ITEM_EDIT_INPUT')
      if ($scope.isLoading) {
        exitCompose()
        return
      }
      // 对比初始化时的信件与退出时的信件，若没有被用户修改，则释放服务器资源并退出(不删除草稿)
      const composeObj = getComposeObject()
      if (angular.equals($scope.lastComposeObj, composeObj)) {
        mailService.cancelComposes($scope.id, false).then(function (results) {
          exitCompose()
        }, function () {
          exitCompose()
        })
        return
      }

      const clickedFuncs = [
        saveDraft,
        exitComposeWithoutDraft
      ]

      $ionicActionSheet.show({
        buttons: [
          { text: "<p class='actionText'>" + $translate.instant('OP.LEAVE_SAVE_DRAFT') + '</p>' },
          { text: "<p class='actionText'>" + $translate.instant('OP.LEAVE_COMPOSE') + '</p>' }
        ],
        cancelText: $translate.instant('OP.CANCEL'),
        buttonClicked: function (index) {
          clickedFuncs[index]()
          return true
        }
      })
      window.removeEventListener('message', closeCloudStorageModal)
    }
    // 离开并保存草稿
    function saveDraft() {
      if (isAttachmentSizeBeyondLimit()) {
        showTip($translate.instant('CODE.COMPOSE.FA_OVERFLOW.PREF_SMTP_MAX_SEND_MAIL_SIZE'))
        return
      }
      composeService.composeMail1($scope.id, getComposeObject(), 'save').then(
        function () {
          $rootScope.$emit('refresh-draft')
          $scope.tip = false
          showTip($translate.instant('MAIL_OP_TIPS.SUCCESS_SAVE_DRAFT'))
          exitCompose()
        }, function (reason) {
          $scope.tip = false
          composeFailHandler(reason)
        }
      )
    }
    // 离开
    function exitComposeWithoutDraft() {
      mailService.cancelComposes($scope.id, false).then(function () {
        $scope.tip = false
        exitCompose()
      }, function () {
        exitCompose()
      })
    }
    // 定时保存草稿
    function AutoSaveDraft() {
      let autoSaveDraftInterval = 180000 // 默认值
      if ($rootScope.settings.autoSaveDraftInterval) {
        autoSaveDraftInterval = $rootScope.settings.autoSaveDraftInterval // 本地配置覆盖值
      } else {
        try {
          autoSaveDraftInterval = User.getConfig().$ajc.user.autoSaveDraftInterval // 接口值
        } catch (error) {
          $utils.$notify.set({ message: $translate.instant('TIPS.SERVER_ERROR') })
          console.log('error type:' + $translate.instant('TIPS.SERVER_ERROR'))
          console.log(error)
        }
      }
      $scope.autoSaveDraftIntervalId = setInterval(function () {
        if (isAttachmentSizeBeyondLimit() || isAttachmentUploading()) {
          return
        }
        composeService.composeMail1($scope.id, getComposeObject(), 'save').then(function (res) {
          $scope.autoSaveDraftId = res.draftId
          $utils.$notify.set({ message: $translate.instant('COMPOSE.AUTOSAVEDRAFT_SUCCESS') })
          if ($scope.action === 'restore') {
            cacheDraftIdforRefresh($scope.autoSaveDraftId)
          }
          setAutoSaveDraftRead($scope.autoSaveDraftId)
        })
      }, autoSaveDraftInterval)
    }
    // 草稿重新编辑状态下，自动保存草稿新生成的draftId要缓存下来,使页面刷新正常
    function cacheDraftIdforRefresh(draftId) {
      localStorage.setItem('autoSaveDraftId', draftId)
    }
    // 自动保存的草稿设为已读
    function setAutoSaveDraftRead(draftId) {
      const params = {
        attrs: {
          flags: {
            read: true
          }
        },
        ids: [draftId]
      }
      Promise.wmCall('mbox:updateMessageInfos', params)
    }
    $scope.openFiles = function (fInput) {
      const deferred = $q.defer()
      // 判断附件是否重复
      function isAttachmentDuplicate(file) {
        return some($scope.attachments, item => {
          return !item.deleted && item.size === file.size && !!~[item.name, item.displayName].indexOf(file.name)
        })
      }
      fInput.onchange = function () {
        // 1. 添加文件到附件列表(返回符合条件的上传文件列表)
        if (some(this.files, isAttachmentDuplicate)) return showTip($translate.instant('ATTACH.DUPLICATEFILE'))
        // 2. 转换成attachment里面的格式
        const files = map(this.files, file => ({
          name: file.name,
          type: 'upload',
          deleted: false,
          blob: file.blob ? file.blob : file,
          size: file.blob ? file.blob.length : file.size
        }))
        $scope.attachments = ($scope.attachments || []).concat(files)
        // 3. 上传文件
        uploadFiles(files, 0)
        fInput.value = null
      }
      deferred.resolve('')
      return deferred.promise
    }
    // 多文件上传
    function uploadFiles(files, i) {
      if (!files[i]) return

      const isUpdate = i === files.length - 1
      getUploadHandler(files[i], isUpdate).finally(_ => uploadFiles(files, ++i))
    }
    $scope.closeAttachmentModal = function () {
      $scope.folderModal.remove()
    }

    // 添加附件
    $scope.addAttachment = function (event) {
      LA.track('A1D2C4')
      const $ajc = User.getConfig()['$ajc']
      const hasPerNetfolder = $ajc['nf'] && $ajc['nf']['enabled']
      const hasEntNetfolder = $ajc['nf'] && $ajc['nf']['enfEnabled']

      _stopPropagation(event || window.event)
      // LKFBK-1081 进入其他页面输入框里面光标没有失去焦点的问题
      document.getElementById('compose-edit-zone').blur()

      $timeout(function () {
        const clickedFuncs1 = {
          local: function () {
            $scope.getLocalFile()
          },
          filecenter: function () {
            $scope.selectFiles()
          },
          cloudStorage: function () {
            $scope.selectCloudStorage()
          }
        }
        const buttons = []
        const customStyle = {
          id: 'custom-action-sheet',
          content: '.action-sheet-option.action-2-file::after {display: none}',
          has: function() {
            return !!document.head.querySelector('#' + this.id)
          },
          add: function() {
            const style = document.createElement('style')
            style.id = this.id
            style.innerText = this.content
            document.head.appendChild(style)
          },
          remove: function() {
            document.head.removeChild(document.head.querySelector('#' + this.id))
          },
          sheetAdd: function() {
            !this.has() && this.add()
          },
          sheetRemove: function() {
            this.has() && this.remove()
          }
        }
        if ($rootScope.settings.featureControl.compose.enableFileUploadFromLocal) {
          buttons.push({ action: 'local', text: "<p class='actionText'>" + $translate.instant('ATTACH.SELECT_FROM_LOCALALBUM') + '</p>', className: 'action-2-file' })
          /*
          * 1. 无法弹窗选择文件对话框，问题在于ionic(https://cdn.bootcdn.net/ajax/libs/ionic/1.3.2/js/ionic.js) 2948行 tapClickGateKeeper
          * 2. 点击按钮后，tapClickGateKeeper触发了3次。第一次是button的tapClick，isIonicTap=true，不阻止默认行为。
          * 第二次是代码中input[type=file]的click，isIonicTap=false但是requireNativeClick=true，不阻止默认行为。
          * 第三次是button的click，isIonicTap=false，阻止默认行为。
          * 这里正常情况只有第一次和第三次的触发，第一次会执行我们绑定的方法，第二次由于没有任何绑定到原生click的行为，就没有影响。
          * 3. 这里造成上传失效的原因是第三次触发被阻止了默认行为，这个原理暂未得知，如果清楚可以记录下到这里。
          * 4. 综上所述，解决方法还可以是让第二次的点击事件在第三次之后触发（暂未考证）或者给触发点击的元素成为requireNativeClick的元素(这里使用的方法)。
          * 5. 对于这类问题，暂未有啥好的解决方法，ioinc do not allow through any click events that were not created by ionic.tap（http://git.mailtech.cn/fe-components/ionic-v1/-/commit/d0047cda446adf1f30e55b056e83bb31ac5c6061），
          * 可以放开不是ionic.tap触发的点击事件，但是更改第三方库逻辑可能导致第三方库运行出现未能预期的情况，特别是这种整体的处理，因此这里先临时处理。
          */
          customStyle.sheetAdd()
          const timerInterval = setInterval(() => {
            const fileNode = document.querySelector('.action-sheet-option.action-2-file p')
            if (fileNode) {
              fileNode.type = 'file'
              clearInterval(timerInterval)
            }
          }, 100)
        }
        if ($rootScope.settings.featureControl.compose.enableFileUploadFromFileCenter) {
          buttons.push({ action: 'filecenter', text: "<p class='actionText'>" + $translate.instant('ATTACH.SELECT_FROM_FILECENTER') + '</p>' })
        }
        if (User.getConfig().xnfSwitch) {
          buttons.push({ action: 'cloudStorage', text: "<p class='actionText'>" + $translate.instant('ATTACH.SELECT_FROM_THIRD_PART') + '</p>' })
        }
        if (!hasPerNetfolder && !hasEntNetfolder) {
          buttons.splice(1, 1)
        }

        const actionSheet = $ionicActionSheet.show({
          buttons: buttons,
          cancelText: $translate.instant('OP.CANCEL'),
          buttonClicked: function (index, button) {
            const { action } = button
            if (action === 'local') {
              LA.track('A1D2C401')
            } else if (action === 'filecenter') {
              LA.track('A1D2C402')
            }
            customStyle.sheetRemove()
            clickedFuncs1[action]()
            setTimeout(function () { // 防止事件冒泡，触发写信iframe focus事件
              actionSheet.$scope && actionSheet.$scope.removeSheet()
            }, 200)
            return false
          },
          cancel: function() {
            customStyle.sheetRemove()
          }
        })
      }, 100)
    }
    // 打开网盘文件选择模态框
    $scope.selectFiles = function () {
      $scope.selectFilesModal = $phoneModal.fromTemplate(require('views/netFolder/selectFilesModal.html'), {
        scope: $scope,
        animation: 'slide-in-up'
      })
      $scope.selectFilesModal.el.style.zIndex = 11
      $scope.selectFilesModal.show()
    }

    $scope.getLocalFile = function () {
      let fInput = document.getElementById('composeUploadInput')
      if (!fInput) {
        fInput = angular.element('<input type="file" class="compose-input-file" name="pic" id="composeUploadInput"/>')[0]
        fInput.multiple = !!$rootScope.settings.featureControl.compose.enableMultipleFileUpload
        document.body.appendChild(fInput)
      }
      $scope.openFiles(fInput).then(function () {
        fInput.click()
        if (!$scope.folderModal || $scope.folderModal._isShown == false) {
          $scope.goFileCenter()
        }
      })
    }

    /* 监听关闭modal 的事件,当返回的时候会退出选择的modal */
    $scope.$on('closeSelectModal', function (event, data) {
      $scope.goBack()
    })
    $scope.$on('checkEmail', function () {
      $scope.$broadcast('BLUR_EMAIL_ITEM_EDIT_INPUT')
    })

    // 监听网盘文件选择事件
    $scope.$on('commitSelected', function (event, data) {
      const attachmentPrepareList = []
      for (let i = 0; i < data.length; i++) {
        if (data[i].type === 'netfolder' || data[i].type === 'trs') {
          attachmentPrepareList.push({
            type: data[i].type,
            _mid: data[i].id,
            displayName: data[i].name,
            name: data[i].name,
            contentType: data[i].contentType,
            size: data[i].size,
            _enfUid: data[i]._enfUid,
            securityLevel: null,
          })
        } else if (data[i].type === 'internal') {
          attachmentPrepareList.push({
            type: data[i].type,
            _mid: data[i].id,
            _part: data[i].partId
          })
        }
      }
      if (attachmentPrepareList.length !== 0) {
        const data = {
          returnInfo: true,
          attrs: {
            attachments: attachmentPrepareList
          }
        }
        mailService.compose($scope.composeId, data, 'continue').then(function (data) {
          if (data && data.code === 'S_OK') {
            updateComposeAttachmentList(data.var.attachments)
          }
        }, function (error) {
          console.log(error)
        })
      }
      $scope.goBack()
    })
    // 更新附件列表
    function updateComposeAttachmentList(attachments) {
      attachments = attachments || []

      // 格式化需要更新的附件
      const updateAttachments = map(attachments, item => {
        if (item.deleted) return

        item.bytesLoaded = 100
        item.status = 'ok'
        item.statusTip = $translate.instant('ATTACH.UPLOAD_SUCCESS')
        item.formattype = $utils.$attachment.getIconClass(item.name, item.contentType)
        return item
      })

      // 更新中转站文件的有效时间
      const trsTypeAttachments = filter(attachments, item => (item.type === 'trs' && !item.limitTime))
      const getFileInfoPromise = trsTypeAttachments.length
        ? composeService.getFilesInfo(map(trsTypeAttachments, '_mid')) : $q.resolve({code: 'S_OK'})
      getFileInfoPromise.then(res => {
        if (res.code !== 'S_OK') return $q.reject(res)

        const resVar = res.var || []
        angular.forEach(updateAttachments, attchment => {
          const index = findIndex(resVar, item => attchment._mid === item.id)
          const fileInfo = resVar[index]
          if (fileInfo) attchment.limitTime = getLimitTime(fileInfo.misc.remaintime)
        })

        // 存在的更新，不存在的加入
        const newAttachments = []
        forEach(updateAttachments, updateAttach => {
          const curIndex = findIndex($scope.attachments, curAttach => curAttach.id === updateAttach.id)
          const curAttach = $scope.attachments[curIndex]
          curAttach ? angular.extend(curAttach, updateAttach) : newAttachments.push(updateAttach)
        })
        $scope.attachments = $scope.attachments.concat(newAttachments)
      })
    }
    // 获取有效期 （5天内有效）
    function getLimitTime(remainTime) {
      let days
      if (remainTime % 86400000 > 0) {
        days = Math.ceil(remainTime / 86400000)
      } else {
        days = Math.floor(remainTime / 86400000)
      }
      return $translate.instant('NETFOLDER.VALIDITY_PERIOD', { days: days })
    }
    /* 定义关闭modal 的函数 */
    $scope.goBack = function () {
      $scope.selectFilesModal.remove()
    }

    $scope.goFileCenter = function () {
      $scope.folderModal = $phoneModal.fromTemplate(require('views/compose/composeAttachment.html'), {
        scope: $scope,
        cache: false,
        animation: 'slide-in-up'
      })
      $scope.folderModal.el.style.zIndex = 11
      $scope.folderModal.show()
    }

    $scope.setEmailEditing = function (value) {
      $scope.emailEditing = value
    }

    // 此处程序设计的事件设置的思路如下
    // 若是单对单事件响应，则采取$rootScope.$emit, $rootScope.$on 方式传递 可以在事件后加入type来区分对应控件
    // 若是单对多的时间响应，第一先发到rootScope中，让Controller知晓，然后再通过当前scope.$broadcast来通知所有子控件
    // 将所有的输入控件设置为inactive状态
    $rootScope.$on('COMPOSE_ACTIVE_EMAIL_EDIT', function ($event, type) {
      $scope.$broadcast('COMPOSE_ACTIVE_EMAIL_EDIT', type)
    })

    $rootScope.$on('COMPOSE_SUMMARY_ACTIVE_CHECK', function ($event) {
      if ($scope.isLoading || $scope.emailEditing) return

      if ($scope.addressList.cc.length == 0 && $scope.addressList.bcc.length == 0) {
        $scope.showSummary = true
      } else {
        $scope.showSummary = false
      }
    })

    $scope.showAllRcpts = function () {
      $scope.showSummary = false
      $scope.$broadcast('BLUR_EMAIL_ITEM_EDIT_INPUT')
      $rootScope.$emit('COMPOSE_HIDE_SELECTED_ADDRESS_to')
    }

    $scope.checkAllRcpts = function () {
      $scope.$broadcast('COMPOSE_ACTIVE_EMAIL_EDIT')
      $rootScope.$emit('COMPOSE_SUMMARY_ACTIVE_CHECK')
    }

    $scope.changeTitle = function (newValue) {
      $rootScope.$emit('COMPOSE_SET_HEADER_TITLE', newValue)
    }

    $scope.tapEditableItems = function () {
      $scope.checkAllRcpts()
      $scope.$broadcast('BLUR_EMAIL_ITEM_EDIT_INPUT')
    }

    $scope.$on('$ionicView.beforeLeave', function (event) {
      let composeObj, confirmMsg, bConfirm
      /** 如果是Android手机物理返回键触发退出写信界面，则采用该方式提示用户是否保存草稿。
       * 区分写信页左上角按钮退出写信，或发送成功退出写信页。
       */
      if (!$scope.exitByCancelBtn) {
        composeObj = getComposeObject()
        if (angular.equals($scope.lastComposeObj, composeObj)) {
          mailService.cancelComposes($scope.id, false)
          return
        }
        confirmMsg = $translate.instant('COMPOSE.SAVE_DRAFT_CONFIRM')
        bConfirm = confirm(confirmMsg)
        if (bConfirm == true) {
          composeService.composeMail1($scope.id, composeObj, 'save').then(function () {
            showTip($translate.instant('MAIL_OP_TIPS.SUCCESS_SAVE_DRAFT'))
            $rootScope.$emit('LIST.REFRESH')
          }, function (reason) {
            if (reason) {
              composeFailHandler(reason)
            }
          })
        } else {
          mailService.cancelComposes($scope.id, false)
        }
      }
      return false
    })

    $scope.composeContentClick = function () {
      $scope.checkAllRcpts()
      $scope.$broadcast('BLUR_EMAIL_ITEM_EDIT_INPUT', 'iFrameFocus')
    }

    $scope.$on('$destroy', function () {
      $scope.composeDestory = true
      $scope.exitByCancelBtn = false
      clearInterval($scope.connectServerInterval)
      $scope.selectCloudStorageModal && $scope.selectCloudStorageModal.remove()
      $rootScope.$off('COMPOSE_ACTIVE_EMAIL_EDIT', 'COMPOSE_SUMMARY_ACTIVE_CHECK')
    })
    // 删除本地附件
    function removeAttachment(index) {
      $scope.attachments.splice(index, 1)
    }

    // 获取附件总大小
    function getAttachmentTotalSize() {
      let totalSize = 0
      if ($scope.attachments) {
        for (let i = 0; i < $scope.attachments.length; i++) {
          const curFile = $scope.attachments[i]
          if (!curFile.deleted && curFile.size) {
            totalSize += parseInt(curFile.size)
          }
        }
      }
      return totalSize
    }

    // 是否有附件正在上传中
    function isAttachmentUploading() {
      if (!hasAttachment()) {
        return false
      }
      return $scope.attachments.some(attach => attach.status === 'uploading')
    }

    function hasAttachment() {
      return $scope.attachments && $scope.attachments.length > 0
    }

    // 检测附件大小是否超出邮件可发送大小
    function isAttachmentSizeBeyondLimit() {
      if (!hasAttachment()) {
        return false
      }
      const $ajc = User.getConfig()['$ajc']
      const maxAttachmentSize = $ajc.user ? $ajc.user.maxAttachmentSize : 0
      return maxAttachmentSize && getAttachmentTotalSize($scope.attachments) > parseInt(maxAttachmentSize)
    }

    // 附件删除
    const $style = angular.element('<style class="c-action-sheet">.action-sheet-open.modal-open .modal { pointer-events: auto;}</style>')
    $scope.$on('$destroy', _ => $style.remove())
    $scope.attachmentCancel = function ($index) {
      // 快速点击关闭模态框问题
      const $body = angular.element(document.body)
      if ($body.hasClass('action-sheet-open')) return
      if (!$body[0].querySelector('.c-action-sheet')) $body.append($style)

      const currentFile = $scope.attachments[$index]
      const handleAttachment = {
        'preview': function () {
          const fileId = currentFile._mid || currentFile.id
          const options = currentFile.type === 'upload'
            ? { attachId: fileId, composeId: $scope.composeId } : { fileId: fileId }
          $scope.curAttachment = currentFile
          globalMailService.openAttachPreviewModal($scope, $utils.$attachment.getPreviewUrl(options))
          // if ($$misc.MD.isAppEmbed && ionic.Platform.isIOS()) $$html.loadURL(url)
          // else if (ionic.Platform.isIOS() || ionic.Platform.isAndroid()) $window.location.href = url
          // else $window.open($sce.trustAsResourceUrl(url))
        },
        'reUpload': function () {
          composeService.deleteTasks($scope.composeId, [currentFile.name]).then(_ => {
            removeAttachment($index)
            getUploadHandler(currentFile)
          })
        },
        'delete': function () {
          composeService.deleteTasks($scope.composeId, [currentFile.name])
          currentFile.deleted = true
          handleAttachmentDelete($index)
        }
      }
      // 附件上传成功的actionSheet选项
      const options = {
        buttons: [
          {
            type: 'delete',
            text: "<p class='actionText'>" + $translate.instant('ATTACH.DELET_ATTECHMENT') + '</p>'
          }
        ],
        cancelText: $translate.instant('OP.CANCEL'),
        buttonClicked: function (index, item) {
          handleAttachment[item.type] && handleAttachment[item.type]()
          return true
        }
      }
      // 附件上传失败的actionSheet选项
      if (currentFile.status == 'failed') {
        options.buttons = [
          {
            type: 'reUpload',
            text: "<p class='actionText'>" + $translate.instant('ATTACH.REUPLOAD_ATTECHMENT') + '</p>'
          },
          {
            type: 'delete',
            text: "<p class='actionText'>" + $translate.instant('ATTACH.DELET_ATTECHMENT') + '</p>'
          }
        ]
      } else if (currentFile.status == 'uploading') { // 附件还在上传过程的actionSheet选项
        options.buttons = [
          {
            type: 'delete',
            text: "<p class='actionText'>" + $translate.instant('ATTACH.CANCEL_ATTECHMENT') + '</p>'
          }
        ]
      } else if (currentFile.name && $utils.$attachment.isSupportPreview(currentFile.name)) { // 附加上传成功并且支持预览的actionSheet选项
        options.buttons.unshift({
          type: 'preview',
          text: "<p class='actionText'>" + $translate.instant('OP.PREVIEW') + '</p>'
        })
      }

      $ionicActionSheet.show(options)
    }
    // 删除已上传服务器的附件
    function handleAttachmentDelete(index) {
      const data = {
        returnInfo: true,
        attrs: {
          attachments: [{
            id: $scope.attachments[index].id,
            deleted: true
          }]
        }
      }
      mailService.compose($scope.composeId, data, 'continue').then(function (data) {
        if (data && data.code === 'S_OK') {
          removeAttachment(index)
        }
      }, function (error) {
        console.log(error)
      })
    }
    $scope.verify = function (verifyCode) {
      if (!verifyCode) {
        return false
      }

      $scope.verifyCode = verifyCode
      $scope.verifyCodeModal.remove()
      composing()
    }

    $scope.cancelVerify = function () {
      $scope.verifyCodeModal.remove()
      $scope.verifyCode = null
    }

    function showTip(message) {
      if ($scope.composeNotify) {
        $scope.composeNotify.show(message)
      } else {
        $scope.composeNotify = $utils.$notify.set({ message: message })
      }
    }
    function _stopPropagation(event) {
      event = event || window.event
      event.preventDefault()
      event.stopPropagation()
    }

    // 退出写信页
    function exitCompose() {
      localStorage.removeItem('autoSaveDraftId')
      clearInterval($scope.autoSaveDraftIntervalId)
      $scope.exitByCancelBtn = true // 页面上退出写信页按钮
      if (backFromCloudStorage) {
        uni.postMessage({
          data: {
            exitComponse: {
              fid: fromId
            }
          }
        })
        if ($rootScope.settings.wechatMiniProgram) {
          uni.reLaunch({
            url: '/pages/main/main'
          })
        } else {
          $state.go('frame.folder', { fid: fromId })
          $rootScope.$emit('refresh-draft')
        }
      } else {
        if (!$ionicHistory.backView()) {
          uni.postMessage({
            data: {
              exitComponse: {
                fid: 1
              }
            }
          })
          if ($rootScope.settings.wechatMiniProgram) {
            uni.reLaunch({
              url: '/pages/main/main'
            })
          } else {
            window.history.go(-1)
          }
        } else {
          // 返回到草稿箱、已发送前，先清除页面缓存
          if (['2', '3'].map(id => `/frame/folder/${id}`).some(item => $ionicHistory.backView().url.startsWith(item))) {
            const backView = $ionicHistory.backView()
            const backViewStateId = [backView.stateId]
            $ionicHistory.clearCache(backViewStateId)
            // 异步是由于clearCache也是异步
            $timeout(function () {
              uni.postMessage({
                data: {
                  exitComponse: {
                    fid: 2
                  }
                }
              })
              if ($rootScope.settings.wechatMiniProgram) {
                uni.reLaunch({
                  url: '/pages/main/main'
                })
              } else {
                window.history.go(-1)
              }
            }, 0)
          } else {
            if ($rootScope.settings.wechatMiniProgram) {
              uni.reLaunch({
                url: '/pages/main/main'
              })
            } else {
              window.history.go(-1)
            }
          }
        }
      }
    }

    // 选择第三方网盘
    $scope.selectCloudStorage = function () {
      $scope.selectCloudStorageModal = $phoneModal.fromTemplate(require('views/netFolder/cloudStorageModal.html'), {
        scope: $scope,
        animation: 'scale-in'
      })
      $scope.selectCloudStorageModal.el.style.zIndex = 11
      $scope.selectCloudStorageModal.show()
      const ln = document.querySelector('#cloudStorageModal')
      ln.src = $$misc.subModule.cloudStorageSrc
      ln.onload = function () {
        const params = {
          params: $scope.cloudStorages,
          type: 'external_nf'
        }
        const targetOrigin = $$misc.subModule.getPostMsgOrigin($utils.$html.getBaseURL())
        ln.contentWindow.postMessage(params, targetOrigin)
      }
      $scope.attachpopover && $scope.attachpopover.hide()
    }

    function closeCloudStorageModal(e) {
      // 不对所有的事件监听（只监听选择保存后和回退的事件）
      if (!~['commit', 'back'].indexOf(e.data.type)) return

      if (e.data.type === 'commit') {
        const cloudStorages = []
        if (e.data.thirdPartFiles.length) {
          e.data.thirdPartFiles.forEach(function (ele) {
            ele.formattype = $utils.$attachment.getExtName(ele.name)
            cloudStorages.push(ele)
          })
        }
        $scope.cloudStorages = uniqBy($scope.cloudStorages.concat(cloudStorages), 'path')
      }
      backFromCloudStorage = true
      $scope.selectCloudStorageModal.remove()
    }

    window.addEventListener('message', closeCloudStorageModal)

    $scope.cloudStoragesDelete = function ($index) {
      $ionicActionSheet.show({
        buttons: [
          { text: '<p class="actionText">' + $translate.instant('ATTACH.DELET_ATTECHMENT') + '</p>' }
        ],
        cancelText: $translate.instant('OP.CANCEL'),
        buttonClicked: function (index) {
          if (index === 0) {
            // 删除第三方附件
            // const scan_name = $scope.cloudStorages[$index].name
            $scope.cloudStorages.splice($index, 1)
          }
          return true
        }
      })
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/mail/compose/composeCtrl.js